// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"df2cab20","355":"228ba77a","422":"3643bc39","444":"3fd13e95","558":"d3368e4d","736":"ebeaa52d","742":"5b4e3eff","783":"0c26e427","882":"37905c38","954":"8e8642e5"}[chunkId] + ".chunk.js";
};